<main id="main" class="main contact-page">
  <section class="contact-section">
    <div class="contact-intro text-center">
      <span class="contact-eyebrow">Centro de ayuda</span>
      <h2>Contáctanos</h2>
      <p>¿Tienes alguna pregunta, problema, sugerencia o reconocimiento? Estamos para ayudarte.</p>
      <div class="service-hours">
        <i class="bi bi-clock" aria-hidden="true"></i>
        <span><strong>Horario de atención:</strong> lunes a viernes, de 9 a 11 a. m. y de 2 a 4 p. m.</span>
      </div>
    </div>

    <aside class="support-guide">
      <div class="support-guide-icon">
        <i class="bi bi-info-circle" aria-hidden="true"></i>
      </div>
      <div>
        <h3>Antes de reportar un error</h3>
        <p>Sigue estas recomendaciones para que podamos atender tu solicitud más rápido:</p>
        <ol>
          <li>Valida que tengas la última versión.</li>
          <li>Intenta nuevamente desde una ventana de incógnito.</li>
          <li>Confirma con un compañero o administrador de cuenta que estás siguiendo los pasos correctos.</li>
          <li>Recolecta toda la evidencia posible: detalle de pasos, imágenes y videos.</li>
          <li>El incidente debe ser reportado por el administrador de cuenta o por un usuario autorizado.</li>
        </ol>
      </div>
    </aside>

    <div class="channels-heading text-center">
      <h3>Soporte de A2 Hacienda</h3>
      <p>Así tu solicitud llegará directamente al equipo indicado.</p>
    </div>

    <div class="row g-4 justify-content-center contact-cards">
      <div class="col-md-6">
        <article class="contact-card h-100">
          <div class="contact-card-header">
            <div class="module-icon">
              <i class="bi bi-receipt" aria-hidden="true"></i>
            </div>
            <div>
              <span>Soporte especializado</span>
              <h4>DIAN y RADIAN</h4>
              <p>Consultas sobre documentos electrónicos y eventos RADIAN.</p>
            </div>
          </div>
          <div class="contact-options">
            <a
              class="contact-option"
              href="https://api.whatsapp.com/send?phone=573045270014"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="contact-option-icon whatsapp-icon">
                <i class="bi bi-whatsapp" aria-hidden="true"></i>
              </span>
              <span class="contact-option-text">
                <small>WhatsApp</small>
                <strong>+57 304 527 0014</strong>
              </span>
              <i class="bi bi-arrow-up-right" aria-hidden="true"></i>
            </a>
            <a class="contact-option" href="mailto:altintegralesdesoftware@gmail.com">
              <span class="contact-option-icon">
                <i class="bi bi-envelope" aria-hidden="true"></i>
              </span>
              <span class="contact-option-text">
                <small>Correo electrónico</small>
                <strong>altintegralesdesoftware&#64;gmail.com</strong>
              </span>
              <i class="bi bi-arrow-up-right" aria-hidden="true"></i>
            </a>
          </div>
        </article>
      </div>
    </div>
  </section>
</main>
